export function checkFields(requiredFields, state) {
    if (!state.filled) {
        let filledCount = 0
        requiredFields.forEach(e => {
            if (state[e] !== '' && state[e] !== null) {
                filledCount += 1
            }
        })
        if (requiredFields.length === filledCount) {
            return true
        }
    }
    return false
}

export function emptyFields(requiredFields, state) {
    if (state.filled) {
        let filledCount = 0
        requiredFields.forEach(e => {
            if (state[e] !== '' && state[e] !== null) {
                filledCount += 1
            }
        })
        if (requiredFields.length === filledCount) {
            return true
        }
    }
    return false
}

export function ValidateEmail(mail) {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail);

}

export function CheckPassword(inputtxt) {
    let passw = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;
    return !!inputtxt.match(passw);
}


export function StateSetterValidator(value, state, callbackFn, errorFn=()=>{}) {
    if(value.every(v=>{
        errorFn()
        return v
    })){
        //console.log('valid')
        if(!state){
            //console.log('callFn')
            callbackFn()
        }
    } else {
        //console.log('invalid')
        if(state){
            //console.log('callFn')
            callbackFn()
        }
    }

}
